import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './styles/global.css'

// Disable logs on production
if (process.env.REACT_APP_ENV === 'prod') {
    console.debug = () => {}
    console.info = () => {}
    console.log = () => {}
}

const root = ReactDOM.createRoot(document.getElementById('root')!)
root.render(<App />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
